var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Menu',{attrs:{"mdList":_vm.mdList},on:{"tourChanged":function($event){return _vm.changeTourSource($event)}}}),_c('TourFrame',{attrs:{"link":_vm.linkStr}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }